<div class="container-tab-lists">
  <mat-tab-group mat-stretch-tabs="false" orientation="vertical" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
    <!--Messages-->
    @if (defaults.isMersyAdminUser || defaults.isMersyOwnerUser) {
      <mat-tab label="Kpi Management">
        <div class="inner-tcontainer-tab">
          <kpiadmin></kpiadmin>
        </div>
      </mat-tab>
    }

    @if (defaults.isMersyAdminUser) {
      <mat-tab label="Schedule Sections">
        <div class="inner-tcontainer-tab">
          <sectionscheduler></sectionscheduler>
        </div>
      </mat-tab>
    }

    @if (defaults.isMersyAdminUser) {
      <mat-tab label="Mass Release/Revoke">
        <div class="inner-tcontainer-tab">
          <massreleaserevoke></massreleaserevoke>
        </div>
      </mat-tab>
    }

  </mat-tab-group>
</div>